import React from "react";
import { useAuthState } from "../context/AuthContext";
import SplashPage from "../pages/SplashPage";
import { Navigate } from "react-router-dom";

const PrivateGuard = ({Component}) => {

    const {authenticated, loading, user} = useAuthState();
    const qr = localStorage.getItem('qr');

    if (loading) {
        return (
            <SplashPage />
        );
    }

    return authenticated && !user.x_is_house_management? <Component /> : <Navigate to={qr? `/qr/${qr}`:"/"} />
};

export default PrivateGuard;